import type {
  ElementTransformer,
  Transformer,
  TextFormatTransformer,
} from '@lexical/markdown';
import {
  $createHorizontalRuleNode,
  $isHorizontalRuleNode,
} from '@lexical/react/LexicalHorizontalRuleNode';

import { TRANSFORMERS } from '@lexical/markdown';

// Note: Newlines are preserved using shouldPreserveNewLines: true
// option in $convertFromMarkdownString and $convertToMarkdownString
// instead of a custom transformer.

// Underline transformer (custom syntax: __text__)
export const UNDERLINE: TextFormatTransformer = {
  format: ['underline'],
  tag: '__',
  type: 'text-format',
};

// Horizontal Rule transformer
export const HORIZONTAL_RULE_TRANSFORMER: ElementTransformer = {
  dependencies: [],
  export: (node) => {
    if (!$isHorizontalRuleNode(node)) {
      return null;
    }
    return '***';
  },
  regExp: /^(---|\*\*\*|___)\s?$/,
  replace: (parentNode) => {
    const line = $createHorizontalRuleNode();
    parentNode.replace(line);
  },
  type: 'element',
};

export const MARKDOWN_TRANSFORMERS: Array<Transformer> = [
  ...TRANSFORMERS,
  UNDERLINE,
  HORIZONTAL_RULE_TRANSFORMER,
];
